import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import $session from "servicestack/session";
import AutoQuery from 'servicestack/auto-query/auto-query.es6'

// import moment from "moment";

export default class NotePromptController {
	constructor(options, $geo) {
		const $ctrl = this;
		basicController($ctrl);
		const {
			request = options.note,
			title
		} = options;
		console.info("options", options);
		$ctrl.request = {
			id: request.id,
			noteText: request.noteText,
		};


		$ctrl.action = request.id ? "Update" : "Create";
		$ctrl.bus = new ServiceBus();
		$ctrl.title = title || `${$ctrl.action} Note...`;
	}

	$onInit() {
		const $ctrl = this;
	}

	submit() {
		const $ctrl = this;
		$ctrl.bus
			.send(`${$ctrl.action}Note.json`, $ctrl.request)
			.then(function (response) {
				$ctrl.$emit("noteSaved", $ctrl);
				$ctrl.$emit("refresh-notes", response);
				$ctrl.$close(response.data);
			});
	}


	dismiss() {
		const $ctrl = this;
		//$ctrl.$emit('listSaved', $ctrl);
		$ctrl.$dismiss();
	}
}
